import algoliasearch from "algoliasearch";

const algolia = algoliasearch(
  process.env.NEXT_PUBLIC_ALGOLIA_APP_ID,
  process.env.NEXT_PUBLIC_ALGOLIA_API_KEY,
);

export const interceptSearchRequests = (transformer) => {
  if (!algolia.execSearch) algolia.execSearch = algolia.search;

  algolia.search = async (requests, requestOptions) => {
    await transformer(requests);

    // Execute the search
    const result = await algolia.execSearch(requests, requestOptions);

    // Dispatch event
    const searchCompletedEvent = new Event("algoliaSearchCompleted");
    window.dispatchEvent(searchCompletedEvent);

    return result;
  };
};

export const getTopNProfiles = async (n) => {
  const index = algolia.initIndex("admityogi_users");
  const result = await index.search("", {
    hitsPerPage: n,
    filters: "show_in_search_results:true",
  });
  for (const hit of result.hits) {
    hit.id = hit.objectID;
  }
  return result.hits;
};

export default algolia;
